<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">项目信息详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
          v-loading="loading"
          :element-loading-text="loadingText"
          :disabled="!IsEdit"
        >
          <el-row>
            <el-col>
              <el-form-item label="项目名称" prop="Name">
                <el-input v-model="data.Name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="资料分类" prop="Category">
                <el-select v-model="data.Category" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in FileCategoryList"
                    :key="item.ParameterKey"
                    :label="item.ParameterName"
                    :value="item.ParameterKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文件类型" prop="Type">
                <el-select v-model="data.Type" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in FileTypeList"
                    :key="item.ParameterKey"
                    :label="item.ParameterName"
                    :value="item.ParameterKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="文件内容/说明" prop="Description">
              <el-input v-model="data.Description" type="textarea" :autosize="{ minRows: 2 }"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="标签" prop="Keyword">
              <el-input
                v-model="data.Keyword"
                type="textarea"
                :autosize="{ minRows: 2 }"
                placeholder="多个标签用空格分割，最多5个标签"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row v-if="assocID">
            <FileList :assocID="assocID" :module="module"></FileList>
          </el-row>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-form>
        <el-form-item class="right" style="width: 134rem;padding-right:5rem">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="saveForm()" :disabled="!IsEdit" v-if="IsEdit">保存</el-button>
        </el-form-item>
      </el-form>
    </zj-layout-footer>
  </zj-layout-container>
</template>


<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import FileList from "./FileList";
export default {
  name: "MaterialInfo",
  controller: "UI",
  action: "MaterialInfo",
  components: {
    FileList,
  },
  data() {
    return {
      data: {
        Category: "",
        Type: "",
        Description: "",
        Name: "",
      },
      assocID: "",
      module: "",
      loading: false,
      loadingText: "加载中...",
      IsEdit: false,
      FileCategoryList: [],
      FileTypeList: [],
      rules: {
        Name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        Category: [
          { required: true, message: "请选择资料分类", trigger: "blur" },
        ],
        Type: [{ required: true, message: "文件类型", trigger: "blur" }],
        Description: [
          { required: true, message: "请输入文件内容/说明", trigger: "blur" },
        ],
        Keyword: [{ required: true, message: "请输入标签", trigger: "blur" }],
      },
    };
  },
  created: function () {
    this.GetMaterialCategory();
    this.GetMaterialFileType();
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.MaterialId) {
      this.assocID = this.$route.query.MaterialId;
    }
    if (this.$route.query.module) {
      this.module = this.$route.query.module;
    }
  },
  mounted: function () {},
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    GetMaterialCategory() {
      new MyApis.MaterialConfigurationApi()
        .GetAllMaterialCategory()
        .then((r) => {
          r = r.data.Data;
          this.FileCategoryList = r.PageContents;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    GetMaterialFileType() {
      new MyApis.MaterialConfigurationApi()
        .GetAllMaterialFileType()
        .then((r) => {
          r = r.data.Data;
          this.FileTypeList = r.PageContents;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.loadingText = "保存中...";
          if (this.$route.query.type == "add") {
            this.Add();
          } else if (this.$route.query.type == "edit") {
            this.Edit();
          }
        } else {
          return false;
        }
      });
    },
    Add() {
      this.data.MaterialId = this.assocID;
      this.data.Validity = 1;
      this.data.CreateTime = new Date();
      this.data.Creater = ZJApp.ZJUser.current.UserName;
      new MyApis.MaterialManagementApi()
        .AddMaterialData(this.data)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    Edit() {
      this.data.ModifyTime = new Date();
      this.data.Modifier = ZJApp.ZJUser.current.UserName;
      new MyApis.MaterialManagementApi()
        .UpdateMaterialData(this.data)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        this.loading = true;
        new MyApis.MaterialManagementApi()
          .GetMaterialDataById({ Id: InfoId })
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
